import { useEffect, useState } from "react";
import api from "../../configs/api";
import ProductCard, {
  ProductSkeleton,
} from "../../components/common/ProductCard";
import { useCart } from "../../context/CartContext";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { addToCart } = useCart();

  const fetchProducts = async () => {
    try {
      setLoading(true);

      const res = await api.get("/products?page=1&limit=100");

      const { products } = res.data.data;

      setProducts(products);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div className="w-full bg-white px-4 md:px-8 lg:px-10 py-16">
      {/* PAGE TITLE */}
      <div className="text-center mb-14">
        <span
          className="text-xs font-medium tracking-widest uppercase"
          style={{ color: "#c020d0", letterSpacing: "0.2em" }}
        >
          [OUR PRODUCTS]
        </span>

        <h1 className="text-3xl md:text-4xl lg:text-5xl text-[#041122] font-heading font-semibold mt-4">
          Explore Our Concrete Solutions
        </h1>
      </div>

      {/* GRID */}
      <div className="grid md:grid-cols-4 gap-y-8 gap-x-4">
        {loading
          ? Array.from({ length: 8 }).map((_, i) => <ProductSkeleton key={i} />)
          : products.map((product, index) => (
              <ProductCard
                key={product._id}
                product={product}
                index={index}
                visible={true}
                onAddToCart={addToCart}
              />
            ))}
      </div>
    </div>
  );
};

export default Products;
